document.addEventListener('DOMContentLoaded', function() {
    const viewOptionsDesktop = document.getElementById('view-options-desktop');
    const viewOptionsMobile = document.getElementById('view-options-mobile');
    const productGrid = document.getElementById('product-grid');

    // Ensure elements exist before attaching event listeners
    if (viewOptionsDesktop && productGrid) {
        viewOptionsDesktop.addEventListener('change', function() {
            const selectedValueDesktop = viewOptionsDesktop.value;
            // Remove old classes
            productGrid.classList.remove('grid--4-col-desktop', 'grid--5-col-desktop', 'grid--3-col-desktop');
            // Add new classes based on selection
            productGrid.classList.add(`grid--${selectedValueDesktop}-col-desktop`);
        });
    }

    if (viewOptionsMobile && productGrid) {
        viewOptionsMobile.addEventListener('change', function() {
            const selectedValueMobile = viewOptionsMobile.value;
            // Remove old classes
            productGrid.classList.remove('grid--2-col-tablet-down');
            // Add new classes based on selection
            productGrid.classList.add(`grid--${Math.min(selectedValueMobile, 2)}-col-tablet-down`);
        });
    }
});


// Function to toggle menu visibility only for screens < 768px
function toggleFooterMenus() {
  if (window.innerWidth < 768) {
    // Add event listener to each menu title
    document.querySelectorAll('.footer-block__heading').forEach(title => {
      title.removeEventListener('click', toggleMenu); // Ensure no duplicate listeners
      title.addEventListener('click', toggleMenu);
    });
  } else {
    // Remove the event listeners if the screen width is >= 768px
    document.querySelectorAll('.footer-block__heading').forEach(title => {
      title.removeEventListener('click', toggleMenu);
    });
  }
}

// Helper function to toggle menu visibility
function toggleMenu(event) {
  const menu = event.target.nextElementSibling;
  if (menu) {
    menu.style.display = menu.style.display === 'none' || menu.style.display === '' ? 'block' : 'none';
  }
}

// Call function on initial load and on window resize
toggleFooterMenus();
window.addEventListener('resize', toggleFooterMenus);



// Ensure the script runs after the page is fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Capture all touchmove listeners and replace them with passive ones
    const interceptTouchmove = (event) => {
        if (!event.defaultPrevented) {
            document.addEventListener('touchmove', event => {}, { passive: true });
        }
    };

    // Add a listener for touchstart to override future touchmove listeners
    document.addEventListener('touchstart', interceptTouchmove, { passive: true });
});
